import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Ghép class Tailwind. Class đứng sau ghi đè class đứng trước.
 *
 * Dùng ở mọi nơi trong bộ giao diện (§9.10). Nhờ `twMerge`, prop `className` của
 * phía gọi luôn thắng class mặc định của component.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
